<template lang="pug">
  .wrap
    page-title.report-title(fontSize='30px')
      | User Profile

    .info-wrap(v-if='!profile.loading')
      div
        h4 First name
        p {{ profile.data.user.firstName }}
      div
        h4 Surname
        p {{ profile.data.user.lastName }}
      div
        h4 Email
        p {{ profile.data.user.email }}
      div
        h4 Phone No.
        p {{ profile.data.user.phoneNum || '-' }}
      div
        h4 Job role
        p {{ profile.data.user.jobRole || '-' }}
      div
        H4 Account status
        p {{ profile.data.user.isActive ? 'Active' : 'Disabled' }}


    .ethos-tabs
      .ethos-tab(@click.stop='setActiveTab("programs")' :class='{active: activeTab === "programs"}') Programs
      .ethos-tab(@click.stop='setActiveTab("courses")' :class='{active: activeTab === "courses"}') Courses

    .filter-download

      .export-buttons
        a(:href="reportCsvUrl")
          el-button EXPORT CSV

    template(v-if='activeTab === "programs"')
      template(v-if='!programs.loading')
        Programs(
          v-if='normalisedProgramData.length'
          :program-list='normalisedProgramData'
        )
        template(v-else) This user has not been assigned to any course.

      template(v-else) Loading...

    template(v-if='activeTab === "courses"')
      template(v-if='!programCourses.loading')
        ProgramCourses(
          v-if='normalisedProgramCourseData.length'
          :program-course-list='normalisedProgramCourseData'
          :selected-program-course='selectedProgramCourse'
          :selected-program-course-attempt='selectedProgramCourseAttempt'
          @open-detail='openProgramCourseDetail'
          @reassign='showReassignConfirm'
        )

        template(v-else) This user has not been assigned to any course.

      template(v-else) Loading...


</template>

<script>
import format from "date-fns/format";
import CrudMixin from "@/shared/mixins/Crud";
import PageTitle from "@/shared/components/layout/PageTitle";
import ProgramCourses from "./ProgramCourses";
import Programs from "./Programs";

export default {
  components: {
    PageTitle,
    ProgramCourses,
    Programs
  },
  mixins: [CrudMixin],
  data() {
    return {
      profile: {
        data: {},
        loading: true
      },
      programCourses: {
        list: [],
        loading: false
      },
      programs: {
        list: [],
        loading: false
      },
      activeTab: "programs",
      selectedProgramCourseId: null
    };
  },
  computed: {
    reportCsvUrl() {
      const params = {
        format: "csv"
      };
      return this.$store.getters["api/generateUrl"]({
        path: `/itrain/reports/courses/company-user/${this.$route.params.id}/`,
        params
      });
    },
    normalisedProgramCourseData() {
      return this.programCourses.list.map(pg => {
        let status = "-";
        if (pg.course.latestPassedAttempt.length) {
          status = "passed";
        } else if (pg.course.latestInProgressAttempt.length) {
          status = "in_progress";
        }

        return {
          ...pg,
          status,
          passed: status === "passed",
          failed: status === "failed",
          inProgress: status === "in_progress",
          pending: status === "-"
        };
      });
    },
    normalisedProgramData() {
      return this.programs.list.map(prog => {
        let status = "-";
        if (prog.isCompleted) {
          status = "passed";
        } else if (prog.hasInProgressCourse) {
          status = "in_progress";
        } else if (prog.hasFailedCourse) {
          status = "failed";
        }

        return {
          ...prog,
          status,
          passed: status === "passed",
          failed: status === "failed",
          inProgress: status === "in_progress",
          pending: status === "-"
        };
      });
    },
    selectedProgramCourse() {
      return (
        this.selectedProgramCourseId &&
        this.normalisedProgramCourseData.find(
          pg => pg.id === this.selectedProgramCourseId
        )
      );
    },
    selectedProgramCourseAttempt() {
      if (!this.selectedProgramCourse) {
        return null;
      }

      if (this.selectedProgramCourse.status === "passed") {
        return this.selectedProgramCourse.course.latestPassedAttempt[0];
      }

      if (this.selectedProgramCourse.status === "in_progress") {
        return this.selectedProgramCourse.course.latestInProgressAttempt[0];
      }

      // if (this.selectedProgramCourse.status === "failed") {
      //   return this.selectedProgramCourse.latestFailedAttempt[0];
      // }

      return null;
    }
  },
  watch: {
    activeTab(nextActiveTab) {
      if (nextActiveTab === "programs") {
        this.loadPrograms();
      } else {
        this.loadCourses();
      }
    }
  },
  methods: {
    async loadUser() {
      this.profile.loading = true;

      this.profile.data = await this.$store.dispatch("api/sendRequest", {
        method: "get",
        url: `/company-users/${this.$route.params.id}/`
      });

      this.profile.loading = false;
    },
    async loadCourses() {
      this.programCourses.loading = true;

      this.programCourses.list = await this.$store.dispatch("api/sendRequest", {
        method: "get",
        url: `/itrain/reports/courses/company-user/${this.$route.params.id}/`
      });

      this.programCourses.loading = false;

      if (this.programCourses.list.length) {
        this.openProgramCourseDetail(this.programCourses.list[0]);
      }
    },
    async loadPrograms() {
      this.programs.loading = true;

      this.programs.list = await this.$store.dispatch("api/sendRequest", {
        method: "get",
        url: `/itrain/reports/programs/company-user/${this.$route.params.id}/`
      });

      this.programs.loading = false;
    },
    async showReassignConfirm(programCourse) {
      await this.$confirm(
        "This will permanently delete all course results for the user. Continue?",
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning"
        }
      );

      await this.reassignProgram(programCourse);

      this.$message({
        type: "info",
        message: "Course re-assigned"
      });
    },
    async reassignProgram(programCourse) {
      await this.$store.dispatch("api/sendRequest", {
        method: "post",
        data: {
          course: programCourse.course.id,
          user: this.profile.data.user.id
        },
        url: `/itrain/courses/re-assignments/`
      });
      this.loadPrograms();
      this.loadCourses();
    },
    openProgramCourseDetail(programCourse) {
      this.selectedProgramCourseId = programCourse.id;
    },
    formattedDate(date) {
      return format(date, "DD/MM/YYYY");
    },
    setActiveTab(tab) {
      this.activeTab = tab;
    }
  },
  created() {
    this.loadUser();
    this.loadPrograms();
  }
};
</script>

<style scoped lang="scss">
@import "~@/assets/scss/_mixins.scss";
h4 {
  @include heading_font($fs: 15px);
}
.edit {
  @include heading_font($fs: 11px);
}

.info-wrap {
  display: flex;
  flex-wrap: wrap;
  max-width: 600px;
  div {
    width: 50%;
    margin: 0 0 20px 0;
    h4 {
      margin-bottom: 5px;
    }
  }
}

.filter-download {
  display: flex;
  justify-content: space-between;
  margin: 0 0 20px 0;
  .el-select {
    width: 300px;
  }
}

.export-buttons {
  margin-left: auto;
}
</style>
